import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.updateUser.loading;
export const reservationsErrorMessage = (state: RootState) =>
  state.reservations.error;
export const reservationsResponse = (state: RootState) =>
  state.reservations.reservationsResponse;
